import { parseCookies, setCookie } from 'nookies';

export class SessionVerificationError extends Error {
  token: string;

  sessionToken: string;

  constructor({ token, sessionToken }) {
    super();
    this.token = token;
    this.sessionToken = sessionToken;
  }
}

/**
 * Convenience function to purge a session from the browser.
 * @param cookies
 */
export const wipeSession = (cookies = null) => {
  setCookie(null, 'seed_jwt', null, {
    maxAge: -1,
    path: '/',
    domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
  });
  localStorage?.removeItem('userState');
  if (cookies) {
    delete cookies.seed_jwt;
  }
};

// TODO:  REMOVE THIS AS IT SHOULDNT WORK ANYMORE
export const getSessionToken = (cookies = null) => {
  cookies = cookies || parseCookies();
  return cookies?.seed_jwt || null;
};

export const getSessionUUID = (sessionToken = null) => {
  sessionToken = sessionToken || getSessionToken();
  const jwtPayload = JSON.parse(
    Buffer.from(sessionToken.split('.')[1], 'base64').toString(),
  );
  /* The UUID is stored differently depending on the login method */
  if (jwtPayload?.iss === 'https://core.seed.com') {
    return jwtPayload.uuid;
  }
  return jwtPayload.sub.split('|')[1];
};

export const verifyPayloadMatch = (token1, token2) => {
  const payload1 = JSON.parse(
    Buffer.from(token1.split('.')[1], 'base64').toString(),
  );
  const email1 = payload1.email || payload1.username;
  const uuid1 = payload1.uuid || payload1.sub?.split('|')[1];

  const payload2 = JSON.parse(
    Buffer.from(token2.split('.')[1], 'base64').toString(),
  );
  const email2 = payload2.email || payload2.username;
  const uuid2 = payload2.uuid || payload2.sub?.split('|')[1];
  if (uuid1 && uuid2 && uuid1 === uuid2) {
    return true;
  }
  if (
    email1 &&
    email2 &&
    email1.trim().toLowerCase() === email2.trim().toLowerCase()
  ) {
    return true;
  }
  return false;
};

/**
 * The optional cookies parameter is essentially for testing.
 *
 * @param {string} token
 * @returns a JWT payload representing the logged in user
 */
export const verifySession = (token, cookies = null) => {
  const sessionToken = getSessionToken(cookies);
  // if we have no session token, we assume we are fine
  if (!sessionToken && token) {
    return true;
  }
  if (!token) {
    wipeSession(cookies);
    throw new SessionVerificationError({
      token,
      sessionToken,
    });
  }
  // tokens don't match
  // compare the UUIDs
  if (token !== sessionToken && !verifyPayloadMatch(token, sessionToken)) {
    wipeSession(cookies);
    throw new SessionVerificationError({
      token,
      sessionToken,
    });
  }
  return true;
};
